import * as R from 'ramda';
import stat from 'utils/stat';
import { IPerson } from 'global';
import { alpha } from 'utils/color';
import intl from 'react-intl-universal';
import { createPortal } from 'react-dom';
import { inject, observer } from 'mobx-react';
import useTheme from 'components/hooks/useTheme';
import React, { useEffect, useState } from 'react';
import { popHistory, pushHistory } from 'utils/history';

import Detail from './FolloweeDetail';
import Button from '../Common/Button';
import ShareToast from './ShareToast';
import AllForPendantV2, {
  IOneButton,
} from '../ComponentPendantV2/AllForPendant';
import RootStore from '../../store/RootStore';
import usePortalDom from '../hooks/usePortalDom';
import wxUtil, { getQueryShareData } from '../../utils/wx';
import activeGalleryInstance from '../GalleryList/ActiveGalleryInstance';

import './AllForPersonDetail.scss';

interface IAllForPersonDetail {
  rootStore?: RootStore;
  hideBack?: boolean;
  showCurrentGallery?: boolean;
  avatar?: string;
}

export const getUrlAvatar = () => {
  const query = new URLSearchParams(window.location.search);
  return query.get('avatar') as string;
};

const Index = (props: IAllForPersonDetail) => {
  const { hideBack, showCurrentGallery, avatar = '' } = props;
  const { relationStore, wxuserStore, uiStore } =
    props.rootStore!;
  const { person, personAlbum, friends } = relationStore;
  const [visible, setVisible] = useState(false);
  const activeGallery = activeGalleryInstance.get();
  const jigsaw = activeGallery ? activeGallery.jigsaw : { bottomShow: false, jigsawList: [] as any[], type: '' };
  const setJigsaw = activeGallery ? activeGallery.setJigsaw : (() => {});

  const { backgroundColor } = useTheme();

  const onHidePage = () => {
    setJigsaw({ bottomShow: false, jigsawList: [], type: '' });
    popHistory();
  };

  useEffect(() => {
    if (person && person.id) {
      setVisible(true);
      pushHistory(`followeedetail_${person.id}`, () => {
        // 清空数据
        relationStore.clearCurrentPerson();
        setJigsaw({ bottomShow: false, jigsawList: [], type: '' });
        setVisible(false);
      });
    } else {
      setVisible(false);
    }
  }, [person]);

  const wrapper = usePortalDom({
    targetClassName: 'all-for-followee-detail',
    parentElement: window.document.getElementById(
      'root-page'
    )! as HTMLDivElement,
  });

  const unfollow = (person: IPerson) => {
    if (wxuserStore.user.is_mock) {
      return wxuserStore.auth();
    }
    uiStore.showToast({
      content: intl.get('Processing'),
    });
    wxuserStore.unfollow(person.id).then(() => {
      uiStore.hideToast();
      uiStore.showToast({
        content: intl.get('Unfollow') + intl.get('Success'),
      });
    });
  };

  const follow = (person: IPerson) => {
    let params = {
      image: person.faceurl,
      name: person.name,
      personid: person.id,
    };
    if (wxuserStore.user.is_mock) {
      return wxuserStore.auth();
    }
    uiStore.showToast({
      content: intl.get('Processing'),
    });
    wxuserStore.follow(params).then(() => {
      relationStore.follower();
      uiStore.hideToast();
      uiStore.showToast({
        content: intl.get('Follow') + intl.get('Success'),
      });
    }).catch((res: any) => {
      uiStore.hideToast();
      if(res.code === 2000203){
        uiStore.showToast({
          //  messge 后端拼写错误，先容错处理
          //  关注人数已达上限，您可以取消关注一位，然后再尝试关注新的人物
          // content: intl.get('Follow') + intl.get('Failed') + (res?.messge ? `: ${res.messge}` : ''),
          content:intl.get('MaxFolloweeNum'),
        });
      } else {
        uiStore.showToast({
          content: intl.get('Follow') + intl.get('Failed') + (res?.messge ? `: ${res.messge}` : ''),
        });
      }
    });
  };

  const [sharePerson, setSharePerson] = useState(0);

  const onShowShare = (personid: string | number) => {
    setSharePerson(Number(personid));
  };

  return visible && wrapper
    ? createPortal(
        <div
          className="all-for-person-detail"
          style={{ backgroundColor: alpha(backgroundColor, 1) }}
        >
          <Detail
            person={person}
            personAlbum={personAlbum}
            followeeList={friends}
            onBack={onHidePage}
            onFollow={follow}
            onUnfollow={unfollow}
            onShowShare={onShowShare}
            jigsaw={jigsaw}
            setJigsaw={setJigsaw}
            rootStore={props.rootStore}
            showCurrentGallery={showCurrentGallery}
          />
          <AllForPendantV2
            cid="person-detail"
            type="pendant"
            api="v2"
            useLocalDom={true}
            container={{
              top: 0,
              bottom: 0,
              left: 0,
              right: 10,
            }}
            buttons={
              [
                window.isweixin
                  ? {
                      child: <span>{intl.get('Download-Pendent')}</span>,
                      event: () => {
                        setJigsaw({
                          type: 'download',
                          bottomShow: true,
                          jigsawList: [],
                        });
                      },
                      type: 'event',
                      show: true,
                    }
                  : undefined,
                {
                  child: <span>{intl.get('ChooseShare')}</span>,
                  event: () => {
                    setJigsaw({
                      type: 'share',
                      bottomShow: true,
                      jigsawList: [],
                    });
                  },
                  type: 'event',
                  show: true,
                },
                !hideBack
                  ? {
                      className: 'pendant-return-wrapper',
                      child: (
                        <Button className="pendant-return">
                          {intl.get('Back Home')}
                        </Button>
                      ),
                      event: () => {
                        onHidePage();
                      },
                      type: 'event',
                      show: true,
                    }
                  : undefined,
              ].filter(Boolean) as IOneButton[]
            }
          />
          {!!sharePerson ? (
            <div key={avatar}>
              <ShareToast
                getDefaultShare={() => {
                  // 全部分享 => 这里的sharePerson是当前分享的人的id, 也就是分享当前人的所有照片
                  const shareQuery = getQueryShareData();
                  return wxUtil.configPersonShare(sharePerson, {
                    title: shareQuery.t,
                    desc: shareQuery.d,
                    image: avatar,
                    avatar: avatar,
                  });
                }}
                onClose={() => setSharePerson(0)}
                onLinkClick={() => {
                  props.rootStore!.uiStore.showToast({
                    content: intl.get('Copyed'),
                  });
                  setSharePerson(0);
                }}
                onEditClick={(options?: any) => {
                  const realOptions = {
                    avatar: avatar,
                    ...R.defaultTo({}, options),
                  };
                  wxUtil.configPersonShare(sharePerson, realOptions);
                  wxUtil.showShareLimitTip(() => {
                    setSharePerson(0);
                  });

                  stat.event('share_desc', {
                    title: options.title,
                    desc: options.desc,
                  });
                }}
              />
            </div>
          ) : null}
        </div>,
        wrapper
      )
    : null;
};

export default inject('rootStore')(observer(Index));
